import React, { Component } from 'react';

class NotFound extends Component {


    render() {

        return (
                
                <div class="notfound">404 Page not found</div>

        )
    
    }

}


export default NotFound;


// WEBPACK FOOTER //
// ./src/components/bewise/notFound.jsx